import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { Callout } from "@src/appV2/redesign/system/ui-components";
import { useHistory } from "react-router-dom";

import { SHIFT_DISCOVERY_EARLY_ACCESS_PATH } from "../../ShiftDiscovery/paths";
import { useShiftModalsDataContext } from "../../ShiftDiscovery/useShiftModalsDataContext";
import { useIsEarlyAccessEnabled } from "../hooks/useIsEarlyAccessEnabled";

export function EarlyAccessCallout() {
  const history = useHistory();
  const { baseNavigationPath } = useShiftModalsDataContext();
  const isEarlyAccessEnabled = useIsEarlyAccessEnabled();

  if (!isEarlyAccessEnabled) {
    return null;
  }

  return (
    <Callout
      aria-label="View Early Access Facilities"
      title="Early Access"
      iconType="star"
      sx={(theme) => ({
        backgroundColor: theme.palette.intent?.success.background,
        color: theme.palette.intent?.success.text,
      })}
      onClick={() => {
        logEvent(APP_V2_USER_EVENTS.EARLY_ACCESS_CALLOUT_PILL_CLICKED, {});
        history.push(`${baseNavigationPath}/${SHIFT_DISCOVERY_EARLY_ACCESS_PATH}`);
      }}
    />
  );
}
